__turbopack_context__.v({
  "SChairSvg": "ehtmsq_SChairSvg",
  "SLoadingIndicator": "ehtmsq_SLoadingIndicator",
  "gradient": "ehtmsq_gradient",
  "inlineCenter": "ehtmsq_inlineCenter",
  "pulse": "ehtmsq_pulse",
  "small": "ehtmsq_small",
  "topCenter": "ehtmsq_topCenter",
});
